import type { ProductCategory } from '../domain/landing.types'

type ProductSectionProps = { items: ProductCategory[] }

export function ProductSection({ items }: ProductSectionProps) {
  return (
    <section className="section product-section" aria-labelledby="products-title">
      <div className="section-heading section-heading--split product-section__heading" id="productos">
        <div>
          <p>CATÁLOGO PÚBLICO</p>
          <h2 id="products-title">Una muestra de lo que podemos suministrar.</h2>
        </div>
        <div className="product-section__aside">
          <span>SELECCIÓN ACTUAL</span>
          <p>
            Productos seleccionados para compra personal, negocio y suministro por volumen. La disponibilidad y las condiciones dependen de presentación, cantidad y destino.
          </p>
        </div>
      </div>

      <div className="product-grid" aria-label="Categorías de producto">
        {items.map((item, index) => (
          <article className={`product-card${index === 0 ? ' product-card--featured' : ''}`} key={item.name}>
            <div className="product-card__topline">
              <span className="product-card__index">0{index + 1}</span>
              <span className="product-card__line" aria-hidden="true" />
            </div>
            <div className="product-card__body">
              <h3>{item.name}</h3>
              <p>{item.description}</p>
            </div>
            <div className="product-card__footer">
              <span className="product-card__availability">{item.availabilityNote}</span>
              <span className="product-card__dash" aria-hidden="true">—</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
